<template>
  <div>
    <h1>{{athlete.name}}</h1>
    <h2>{{athlete.team_abbr}}</h2>
    <v-data-table :headers="headers" :items="results"
      class="elevation-1" :custom-sort="customSort" disable-initial-sort>
      <template v-slot:items="props">
        <tr :style="{backgroundColor: props.item.backgroundColor}">
          <td>{{ props.item.eventNo }}</td>
          <td>{{ props.item.eventTitle }}</td>
          <td>{{ props.item.place }}</td>
          <td>{{ props.item.points }}</td>
          <td>{{ props.item.seed }}</td>
          <td>{{ props.item.finish }}</td>
          <td>{{ props.item.delta }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  methods: {
    customSort(items, index, isDesc) {
      if(index===null) {
        return items;
      }
      items.sort((a, b) => {
        if (!isDesc) {
          return a[index] < b[index] ? -1 : 1;
        } else {
          return b[index] < a[index] ? -1 : 1;
        }
      });
      if(index==='place' || index===null) {
        return [].concat(...
          items.filter((el) => el.place!==0),
          items.filter((el) => el.place===0));
      }
      return items;
    },
    pad(n) {
      return `00${n}`.slice(-2);
    },
    getTime(t) {
      if (t === 'DQ' || t === 'NS') return t

      if(t > 60) {
        return `${Math.floor(t/60)}:${this.pad(Math.floor(t%60))}.${this.pad(Math.floor((t%1)*100))}`;
      }
      return `${this.pad(Math.floor(t%60))}.${this.pad(Math.floor((t%1)*100))}`;
    },
    seedTime({time}) {
      if (time === 0 || time === null) {
        return 'NT'
      } else {
        return time
      }
    },
    finishTime({time,stat}) {
      if(stat.trim() === '') {
        return time
      } else if(stat === 'Q') {
        return 'DQ'
      }
      return 'NS'
    },
    delta({seed, finish}) {
      if (seed === 'NT' || finish === 'NS' || finish === 'DQ') {
        return 'NA'
      } else {
        return (finish - seed).toFixed(2)
      }
    },
    rowColor({delta}) {
      if (delta === "NA") return 'transparent'

      if (delta <= 0) {
        return '#DFF9D1'
      } else {
        return '#F9D1DF'
      }
    },
  },
  data: () => ({
    headers: [
      {text: "No", value: "eventNo", align: "left", sortable: true},
      {text: "Event", value: "eventTitle", align: "left", sortable: true},
      {text: "Place", value: "place", align: "left", sortable: true},
      {text: "Points", value: "points", align: "left", sortable: true},
      {text: "Seed", value: "seed", align: "left", sortable: true},
      {text: "Finish", value: "finish", align: "left", sortable: true},
      {text: "Change", value: "delta", align: "left", sortable: true},
    ],
    athlete: {name: "", team_abbr: ""},
    results: []
  }),
  created() {
    let date = this.$route.query.date;
    let teams = this.$route.query.team;
    let athleteNo = this.$route.query.athleteno;
    this.$http.get(`${process.env.VUE_APP_API_URL}/athlete?date=${date}&athlete=${athleteNo}&team=${teams.join("&team=")}`)
      .then(function(data) {
        if(data !== null && data.body != null && data.body.length > 0) {
          this.athlete = {
            name: `${data.body[0].first_name} ${data.body[0].initial} ${data.body[0].last_name}`,
            team_abbr: data.body[0].team_abbr
          };
          this.results = data.body.map(row => ({
            eventNo: row.event_no,
            eventTitle: `${row.gender} ${row.agegroup} ${row.event_dist} ${row.stroke}`,
            place: row.fin_place,
            points: row.ev_score,
            seed: this.getTime(this.seedTime({time: row.actualseed_time})),
            finish: this.getTime(this.finishTime({time: row.fin_time, stat: row.fin_stat})),
            delta: this.delta({ seed: this.seedTime({time: row.actualseed_time}), finish: this.finishTime({time: row.fin_time, stat: row.fin_stat}) }),
            backgroundColor: this.rowColor({delta: this.delta({ seed: this.seedTime({time: row.actualseed_time}), finish: this.finishTime({time: row.fin_time, stat: row.fin_stat}) })})
          }));
        }
      });
  }
}
</script>
